export default "__VITE_ASSET__1bb3aebd__"